import TooltipWrapper from "@components/TooltipWrapper";
import CodeEditorContext from "@context/CodeEditorContext";
import SettingsControlButton from "@components/SettingsControlButton";
import { useContext, type ReactElement } from "react";
import {
    EditorSettingsData,
    EditorSettingsKeys,
} from "@utils/configs/editorConfigData";
import "./style.css";

interface IEditorSettingsButtonsData {
    currentValue: number;
    settingsKey: EditorSettingsKeys;
    onValueChange: (newValue: number) => void;
}

const CodeEditorSettingsToolbar = (): ReactElement => {
    const {
        editorFontSize,
        editorLineHeight,
        changeFontSize,
        changeLineHeight,
    } = useContext(CodeEditorContext);

    const buttonsData: IEditorSettingsButtonsData[] = [
        {
            currentValue: editorLineHeight,
            settingsKey: EditorSettingsKeys.LINE_HEIGHT,
            onValueChange: changeLineHeight,
        },
        {
            currentValue: editorFontSize,
            settingsKey: EditorSettingsKeys.FONT_SIZE,
            onValueChange: changeFontSize,
        },
    ];

    return (
        <div className="editor-settings-toolbar">
            {buttonsData.map((buttonData: IEditorSettingsButtonsData) => (
                <TooltipWrapper
                    key={buttonData.settingsKey}
                    tooltipText={
                        EditorSettingsData[buttonData.settingsKey].tooltip
                    }
                >
                    <SettingsControlButton
                        iconName={
                            EditorSettingsData[buttonData.settingsKey].iconName
                        }
                        currentValue={buttonData.currentValue}
                        values={
                            EditorSettingsData[buttonData.settingsKey].values
                        }
                        units={EditorSettingsData[buttonData.settingsKey].units}
                        onValueChange={buttonData.onValueChange}
                    />
                </TooltipWrapper>
            ))}
        </div>
    );
};

export default CodeEditorSettingsToolbar;
